// =======================================
// DON'T BE BARBARIC! MAINTAIN SORT ORDER!
// =======================================
export var FeatureFlags;
(function (FeatureFlags) {
    FeatureFlags["aiLogs"] = "ai-logs";
    FeatureFlags["AiObservabilityMonitoring"] = "ai-observability-monitoring";
    FeatureFlags["AiRunExplorer"] = "ai-run-explorer";
    FeatureFlags["AlertAnalysisRcaAgent"] = "alert-analysis-rca-agent";
    FeatureFlags["AllowLeadingWildcard"] = "allow-leading-wildcard";
    FeatureFlags["ApiTokenRoles"] = "api-token-roles";
    FeatureFlags["ApmV2"] = "apm-v2";
    FeatureFlags["App360HomeDashboard"] = "app360-home-dashboard";
    FeatureFlags["AppPerformanceMonitoring"] = "app-performance-monitoring";
    FeatureFlags["AskNicely"] = "ask-nicely";
    FeatureFlags["BackendUnifiedAlerts"] = "backend-unified-alerts";
    FeatureFlags["ColdTierSearch"] = "cold-tier-search";
    FeatureFlags["CompareSpans"] = "compare-spans";
    FeatureFlags["ConsumptionBilling"] = "consumption-billing";
    FeatureFlags["ConsumptionBillingBanner"] = "consumption-billing-banner";
    FeatureFlags["ConsumptionTrial"] = "consumption-trial";
    FeatureFlags["CorrelatedEventsUi"] = "correlated-events-ui";
    FeatureFlags["Coupons"] = "coupons";
    FeatureFlags["CustomDrilldownLinks"] = "custom-drilldown-links";
    FeatureFlags["DeploymentEvents"] = "deployment-events";
    FeatureFlags["DeprecatedTriggeredAlert"] = "hide-deprecated-triggered-alert";
    FeatureFlags["disableWildCardQueryV2"] = "disable-wildcard-query-v2";
    FeatureFlags["DiscoverToExploreBanner"] = "discover-to-explore-banner";
    FeatureFlags["DiyDataParsing"] = "diy-data-parsing";
    FeatureFlags["editQueryDsl"] = "edit-query-dsl";
    FeatureFlags["experimentalApiGateway"] = "experimental-api-gateway";
    FeatureFlags["ExploreAsDefault"] = "explore-as-default";
    FeatureFlags["ExploreAutoRefresh"] = "explore-auto-refresh";
    FeatureFlags["ExploreK8sLogMetrics"] = "explore-k8s-log-metrics";
    FeatureFlags["ExploreMetricsMode"] = "explore-metrics-mode";
    FeatureFlags["ExplorePreferencesPage"] = "explore-preferences-page";
    FeatureFlags["ExploreTracesMode"] = "explore-traces-mode";
    FeatureFlags["GroupByDropFilter"] = "group-by-drop-filter";
    FeatureFlags["HighlightQueryContainsQuery"] = "highlight-query-contains-query";
    FeatureFlags["IgnoreMetricsDropFiltersLimit"] = "ignore-metrics-drop-filters-limit";
    FeatureFlags["IgnoreNewAccount"] = "ignore-new-account";
    FeatureFlags["IntegrationHubCustomPages"] = "integration-hub-custom-pages";
    FeatureFlags["IntegrationsDashboards"] = "integrations-dashboards";
    FeatureFlags["InvestigateTriggeredAlerts"] = "investigate-triggered-alerts";
    FeatureFlags["IQonLegacyHistory"] = "iqon-legacy-history";
    FeatureFlags["KeepLoggedInToggle"] = "keep-logged-in-toggle";
    FeatureFlags["kibanaAdvisor"] = "kibana-advisor";
    FeatureFlags["Kube360Livetail"] = "kube360-livetail";
    FeatureFlags["logPatternsUi"] = "log-patterns-ui";
    FeatureFlags["LogsEventManagementOpen360"] = "logs-event-management-open360";
    FeatureFlags["LogsToMetrics"] = "logs-to-metrics";
    FeatureFlags["LogsToMetricsHistogram"] = "logs-to-metrics-histogram-buckets";
    FeatureFlags["M3dbMetricsAccount"] = "m3db-metrics-account";
    FeatureFlags["ManageAccountsRedesign"] = "manage-accounts-redesign";
    FeatureFlags["ManageConsumptionAccounts"] = "manage-consumption-accounts";
    FeatureFlags["ManualRestore"] = "manual-log-restore";
    FeatureFlags["MaxNumberOfTimeSeriesBigger"] = "max-number-of-time-series-bigger";
    FeatureFlags["metricsProduct"] = "metrics-product";
    FeatureFlags["NewAppOss"] = "new-app-oss";
    FeatureFlags["NewAppRouter"] = "new-app-router";
    FeatureFlags["NewAppToggle"] = "new-app-toggle";
    FeatureFlags["NewDropMetrics"] = "new-drop-metrics";
    FeatureFlags["NewNavigation"] = "new-navigation";
    FeatureFlags["NewOptimizersPage"] = "new-optimizers-page";
    FeatureFlags["ObservabilityHomeDashboard"] = "observability-home-dashboard";
    FeatureFlags["oiqCapNotifications"] = "oiq-cap-notifications";
    FeatureFlags["oiqHermesGeneralBuilderConsumptionTracking"] = "oiq-hermes-general-builder-consumption-tracking";
    FeatureFlags["oiqIntegrations"] = "oiq-integrations";
    FeatureFlags["oiqRecommendations"] = "oiq-recommendations";
    FeatureFlags["oiqHermesSettingsPage"] = "oiq-hermes-settings-page";
    FeatureFlags["oiqFeedbackLearning"] = "oiq-feedback-learning";
    FeatureFlags["Open360MoveNotice"] = "open360-move-notice";
    FeatureFlags["Open360OrionMerge"] = "open360-orion-merge";
    FeatureFlags["PayWithAwsBannerForCC"] = "pay-with-aws-banner-for-cc";
    FeatureFlags["PlanAndBillingMetricsUi"] = "plan-and-billing-metrics-ui";
    FeatureFlags["PrivateDashboards"] = "private-dashboards";
    FeatureFlags["RealUserMonitoring"] = "real-user-monitoring";
    FeatureFlags["SecurityRuleRiskScore"] = "security-rule-risk-score";
    FeatureFlags["ServiceListMap"] = "service-list-map";
    FeatureFlags["ServiceMapFromMetrics"] = "service-map-from-metrics";
    FeatureFlags["SiemOpen360"] = "siem-open-360";
    FeatureFlags["SiemUnidashSummary"] = "siem-unidash-summary";
    FeatureFlags["SiemUnidash"] = "siem-unidash";
    FeatureFlags["SPMCustomFilters"] = "spm-custom-filters";
    FeatureFlags["styleguide"] = "styleguide";
    FeatureFlags["SubAccountsSsoGroups"] = "sub-accounts-sso-groups";
    FeatureFlags["TelemetryAgentFleet"] = "telemetry-agent-fleet";
    FeatureFlags["TextToLucene"] = "text-to-lucene";
    FeatureFlags["TracingOpen360"] = "tracing-open-360";
    FeatureFlags["UnifiedDashboardsAnnotations"] = "unified-dashboards-annotations";
    FeatureFlags["UnifiedDashboardsIncreasedSeriesLimit"] = "unified-dashboards-increased-series-limit";
    FeatureFlags["UnifiedDashboardsOssFolders"] = "unified-dashboards-oss-folders";
    FeatureFlags["UnifiedDashboardsOssImport"] = "unified-dashboards-oss-import";
    FeatureFlags["UnifiedDashboardsProactiveExtracter"] = "unified-dashboards-proactive-extracter";
    FeatureFlags["UnifiedDashboardsWarm"] = "unified-dashboards-warm";
    FeatureFlags["UpToSubAccountBackend"] = "flexible-volume-management-allowed";
    FeatureFlags["UpToSubAccountUI"] = "upto-sub-account";
    FeatureFlags["WelcomePageBar"] = "welcome-page-bar";
})(FeatureFlags || (FeatureFlags = {}));
// =======================================
// DON'T BE BARBARIC! MAINTAIN SORT ORDER!
// =======================================
//# sourceMappingURL=feature-flags.enum.js.map